import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ComingSoon from './components/ComingSoon';  

function Router() {
  return (
    <Switch>
      <Route path="/" component={ComingSoon} />
    </Switch>
  );
}
export default Router;



// WEBPACK FOOTER //
// ./src/Router.jsx